import service from "../api/services/userService";
import VueCookies from 'vue-cookies';
import constants from "../utils/constants";

const token = setToken();
const user = setUser();
const myInstitute = JSON.parse(localStorage.getItem("myInstitute"));
const modules = JSON.parse(localStorage.getItem("modules"));

function setUser () {
    let user = sessionStorage.getItem("user");
    let usr = localStorage.getItem("user");
    if (usr) {
        user = JSON.parse(localStorage.getItem("user"));
        sessionStorage.setItem('user',localStorage.getItem("user"));
        sessionStorage.setItem('auth_token',localStorage.getItem("auth_token"));
        
    }
    if(user){
        user = JSON.parse(sessionStorage.getItem("user"));
    }
    else{
        user = VueCookies.get('userDetails') 
        if(user && user.user){
            sessionStorage.setItem('user',JSON.stringify(user.user));
        }
    }
    return user;
}
function setToken () {
    let token = sessionStorage.getItem("auth_token");
    let usr = JSON.parse(localStorage.getItem("user"));
    if (usr && usr.institute===constants.ONLINE_INSTITUTE_ID) {
        token = localStorage.getItem("auth_token");
        sessionStorage.setItem('user',localStorage.getItem("user"));
        sessionStorage.setItem('auth_token',localStorage.getItem("auth_token"));
        
    }
    return token;
}
export default {
    namespaced: true,
    state: {
        status: token ? { loggedIn: true } : {},
        token: token,
        user: user,
        myInstitute: myInstitute,
        signUpData: null,
        signUpStudentData: null,
        pendingTestList: null,
        isDefaultInstitute: false,
        modules: modules,
    },

    mutations: {
        updateIsDefaultInstitute(state, payload) {
            state.isDefaultInstitute = payload;
        },
        updateUser(state, user) {
            if (user) {
                sessionStorage.setItem("user", JSON.stringify(user));
            }
            state.user = user;
        },
        updateModules(state, response) {
            sessionStorage.setItem("modules", JSON.stringify(response));
            state.modules = response;
        },
        changeUserName(state, user) {
            if (user && user.username) {
                state.user.username = user.username;
            }
        },
        loginSuccess(state, response) {
            state.status = { loggedIn: true };
            state.token = response.token;
            state.user = response.user;

        },
        logOut(state) {
            state.status = {};
            state.token = null;
            state.user = null;
        },
        myInstitute(state, response) {
            localStorage.setItem("myInstitute", JSON.stringify(response));
            state.myInstitute = response;
        },
        setSignUpData(state, signUpData) {
            state.signUpData = signUpData;
        },
        setSignUpStudentData(state, signUpStudentData) {
            state.signUpStudentData = signUpStudentData;
        },
        updatePendingTestList(state, payload) {
            state.pendingTestList = payload;
        }
    },
    actions: {
        me(context) {
            return service.me().then((response = {}) => {
                context.commit("updateUser", response.data.responseData);
                const finalResponse = response.data.responseData;
                // TODO : CHANGE THIS HARD CODED ROLE _ ID OF PARENT TO CONST FILE.
                if(finalResponse.role_id === constants.ROLES_ID.PA){
                    localStorage.setItem("Related_student_for_parent",JSON.stringify(finalResponse.related_student_generated))
                }
                return finalResponse;
            });
        },
        logIn(context,reqData) {
            return service.logIn(reqData).then((response = {}) => {
                context.commit("loginSuccess", response.responseData);
                return response.responseData.user;
            });
        },
        getInstituteDetails(context) {
            return service.getInstituteDetails().then((response = {}) => {
                context.commit("myInstitute", response.data.responseData);
                return response.data.responseData;
            });
        },
        createUserNameAndPassword(context, reqData) {
            return service.createUserNameAndPassword(reqData).then((response = {}) => {
                context.commit("changeUserName", response.responseData.user);
                return response.responseData;
            });
        },
        forgotPassword(context, reqData) {
            return service.forgotPassword(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        checkUserName(context, { username }) {
            return service.checkUserName(username).then((response = {}) => {
                return response.responseData;
            }).catch((error) => {
                return Promise.reject(error);
            });
        },
        logOut(context) {
            return service.logOut().then((response = {}) => {

                context.commit("logOut");
                return response;
            });

        },
        register(context, user) {
            return service.create(user);
        },
        resetPassword(context, reqData) {
            return service.resetPassword(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        resetPasswordByUserId(context, reqData) {
            return service.resetPasswordByUserId(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        verifyOTP(context, reqData) {
            return service.verifyOTP(reqData).then((response = {}) => {
                return response.responseData;
            }).catch((error) => {
                return Promise.reject(error);
            });
        },
        getExternalRoles(context, reqData) {
            return service.getExternalRoles(reqData).then((response = {}) => {

                return response.data.responseData.roles;
            }).catch((error) => {
                return Promise.reject(error);
            });
        },
        signUp(context, reqData) {
            return service.signUp(reqData).then((response = {}) => {
                context.commit("setSignUpData", null);
                context.commit("setSignUpStudentData", null);
                return response.responseData;
            });
        },
        getSubjectUsers(context, reqData) {
            return service.getSubjectUsers(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        setSignUpData(context, data) {
            context.commit("setSignUpData", data);
        },
        setSignUpStudentData(context, data) {
            context.commit("setSignUpStudentData", data);
        },
        updateUser(context, data) {
            context.commit("updateUser", data);
        },
        getClasses(context) {
            return service.getClasses().then((response = {}) => {
                return response.data.responseData;
            }).catch((error) => {
                return Promise.reject(error);
            });
        },
        getSelfSignedUpUsers(context, reqData) {
            return service.getSelfSignedUpUsers(reqData).then((response = {}) => {
                return response.responseData;
            }).catch((error) => {
                return Promise.reject(error);
            });
        },
        approveOrDisapproveUser(context, reqData) {
            return service.approveOrDisapproveUser(reqData).then((response = {}) => {
                return response.responseData;
            }).catch((error) => {
                return Promise.reject(error);
            });
        },
        approveOrSaveStudent(context, reqData) {
            return service.approveOrSaveStudent(reqData).then((response = {}) => {
                return response.responseData;
            }).catch((error) => {
                return Promise.reject(error);
            });
        },
        setUserActiveStatus(context, reqData) {
            return service.setUserActiveStatus(reqData).then((response = {}) => {
                return response.responseData;
            }).catch((error) => {
                return Promise.reject(error);
            });
        },
        allocateBatch(context, reqData) {
            return service.allocateBatch(reqData).then((response = {}) => {
                return response.responseData;
            }).catch((error) => {
                return Promise.reject(error);
            });
        },
        changePassword(context, reqData) {
            return service.changePassword(reqData).then((response = {}) => {
                return response.responseData;
            }).catch((error) => {
                return Promise.reject(error);
            });
        },
        updateProfile(context, formData) {
            return service.updateProfile(formData).then((response = {}) => {
                context.commit("updateUser", response.responseData.user);
                return response.responseData;
            }).catch((error) => {
                return Promise.reject(error);
            });
        },
        updateExternalUser(context, formData) {
            return service.updateExternalUser(formData).then((response = {}) => {

                return response.responseData;
            }).catch((error) => {
                return Promise.reject(error);
            });
        },
        updateUserActivity(context, formData) {
            return service.updateUserActivity(formData).then((response = {}) => {

                return response.responseData;
            }).catch((error) => {
                return Promise.reject(error);
            });
        },
        getPackages(context, reqData) {
            return service.getPackages(reqData).then((response = {}) => {

                return response.responseData;
            }).catch((error) => {
                return Promise.reject(error);
            });
        },
        createPackageOrder(context, reqData) {
            return service.createPackageOrder(reqData).then((response = {}) => {
                return response.responseData;
            }).catch((error) => {
                return Promise.reject(error);
            });
        },
        getListOfPendingTests(context, reqData) {
            return service.getListOfPendingTests(reqData).then((response = {}) => {
                context.commit('updatePendingTestList', response.responseData.list);
                return response.responseData;
            });
        },
        setPendingTestList(context, payloadata) {
            context.commit('updatePendingTestList', payloadata);            
        },
        updateTransactionStatus(context, reqData) {
            return service.updateTransactionStatus(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        getUserByEmail(context, reqData) {
            return service.getUserByEmail(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        deleteUser(context, reqData) {
            return service.deleteUser(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        
        getTeacherDetails(context, reqData) {
            return service.getTeacherDetails(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
		getUserPurchasedModules(context, reqData) {
            return service.getUserPurchasedModules(reqData).then((response = {}) => {
                context.commit("updateModules", response.responseData);
                return response.responseData;
            });
        },
		getTeacherSubject(context, reqData) {
            return service.getTeacherSubject(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
		validateEmail(context, reqData) {
            return service.validateEmail(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
		addLicenseSubscription(context, reqData) {
            return service.addLicenseSubscription(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
		renewSubscription(context, reqData) {
            return service.renewSubscription(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        verifyOTPWebsite(context,reqData) {
            return service.verifyOTPWebsite(reqData).then((response = {}) => {
                return response.responseData;
            }).catch((error) => {
                return Promise.reject(error);
            }); 
        },
        resendOtpWebsite(context,reqData) {
            return service.resendOtpWebsite(reqData).then((response = {}) => {
                return response.responseData;
            }).catch((error) => {
                return Promise.reject(error);
            }); 
        },
        verifyCoupon(context, reqData) {
            return service.verifyCoupon(reqData).then((response = {}) => {
                return response.responseData;
            }).catch((error) => {
                return Promise.reject(error);
            });
        },
        applyCoupon(context, reqData) {
            return service.applyCoupon(reqData).then((response = {}) => {
                return response.responseData;
            }).catch((error) => {
                return Promise.reject(error);
            });
        },
        getPriceDetails(context, reqData) {
            return service.getPriceDetails(reqData).then((response = {}) => {
                return response.responseData;
            }).catch((error) => {
                return Promise.reject(error);
            });
        },
        loginMyt(context, reqData) {
            return service.loginMyt(reqData).then((response = {}) => {
                if (response.responseData.token && reqData.password) {
                    context.commit("loginSuccess", response.responseData);
                }
                return response.responseData;
            }).catch((error) => {
                return Promise.reject(error);
            });
        },
        verifyOtpMyt(context, reqData) {
            return service.verifyOtpMyt(reqData).then((response = {}) => {
                if (!response.responseData.isNewUser) {
                    context.commit("loginSuccess", response.responseData);

                }
                return response.responseData;
            }).catch((error) => {
                return Promise.reject(error);
            });
        },
        resendOtpMyt(context, reqData) {
            return service.resendOtpMyt(reqData).then((response = {}) => {
                return response.responseData;
            }).catch((error) => {
                return Promise.reject(error);
            });
        },

        signupMyt(context, reqData) {
            return service.signupMyt(reqData).then((response = {}) => {
                if (response.responseData.isNewUser) {
                    context.commit("loginSuccess", response.responseData);

                }
                return response.responseData;
            }).catch((error) => {
                return Promise.reject(error);
            });
        },
        logOutMyt(context) {
            return service.logOutMyt().then((response = {}) => {

                context.commit("logOut");
                return response;
            });

        },
        importStudents(context, reqData) {
            return service.importStudents(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        downloadStudentTemplate(context) {
            return service.downloadStudentTemplate().then((response) => {
                return response;
            });
        }
    }
};